import { Module } from "../plugins/_application";
import ModalBox from '../utils/_modal-box.js';

export default class VideoModal extends Module {
    ready() {

        new ModalBox('.open-video-modal');
    }
}